import React from 'react'
import { Link } from 'react-router-dom'
const News = () => {
  return (
      <>
      <div className="innerslide">
      <ul className="breadcrumb">
       <li><Link to="/"> Home</Link> </li>
       <li> News </li>
   </ul>
</div>
<div className="innersec">
 <div className="container">
  <div className="row">
       <div className="col-lg-12">
            <h1> News </h1>
       </div>
  </div> 
  <div className="row tabs-dynamic">
           <div className="col-md-3">
               <div className="count-val">
                   <p>Total Count: </p>
               </div>
           </div>
           <div className="col-md-3">
               <div className="month-selection">
                  <select className="yearSelection">
                       <option className="2024" selected>2024</option>
                       <option className="2023">2023</option>
                   </select>
               </div>
           </div>
           <div className="col-md-3">
               <div className="month-selection">
                   <select className="monthSelect">
                       <option value="0">All Month</option>
                       <option value="1">Jan</option>
                       <option value="2">Feb</option>
                       <option value="3">Mar</option>
                       <option value="4">Apr</option>
                       <option value="5">May</option>
                       <option value="6">Jun</option>
                       <option value="7">Jul</option>
                       <option value="8">Aug</option>
                       <option value="9">Sep</option>
                       <option value="10">Oct</option>
                       <option value="11">Nov</option>
                       <option value="12">Dec</option>
                   </select>
               </div>
           </div>
           <div className="col-md-3">
               <div className="searchBox">
                   <input type="text" id="myInput" name="name" autocomplete="off" placeholder="Search Here.." />
               </div>
           </div>
       </div>
       <div className="row years year2024 showYear">
                <div className="newscountbox">

                 <div className="newsCount " data-month="1">
                   <div className="news-block">
                       <div className="news-head">
                           <h4>DD | MM</h4>
                           <h3>News Heading</h3>
                       </div>
                       <div className="news-content">
                           <p>Coming Soon...</p>
                       </div>
                       <div className="attachment">
                           <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
                       </div>
                   </div>
               </div>
               <div className="newsCount" data-month="2">
                   <div className="news-block">
                       <div className="news-head">
                           <h4>DD | MM</h4>
                           <h3>News Heading</h3>
                       </div>
                       <div className="news-content">
                           <p>Stay Tunned  for more Updates Stay Tunned  For More Updates</p>
                       </div>
                       <div className="attachment">
                           <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
                       </div>
                   </div>
               </div>
                   </div>
               <div className="load-more">
                   <div className="next">Show More</div>
               </div>
          </div>
       <div className="row years year2023">
                <div className="newscountbox">
                 <div className="newsCount " data-month="1">
                   <div className="news-block">
                       <div className="news-head">
                           <h4>DD | MM</h4>
                           <h3>News Heading</h3>
                       </div>
                       <div className="news-content">
                           <p>Coming Soon...</p>
                       </div>
                       <div className="attachment">
                           <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
                       </div>
                   </div>
               </div>
               <div className="newsCount" data-month="2">
                   <div className="news-block">
                       <div className="news-head">
                           <h4>DD | MM</h4>
                           <h3>News Heading</h3>
                       </div>
                       <div className="news-content">
                           <p>Stay Tunned  for more Updates Stay Tunned  For More Updates</p>
                       </div>
                       <div className="attachment">
                           <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
                       </div>
                   </div>
               </div>
               <div className="newsCount" data-month="2">
                   <div className="news-block">
                       <div className="news-head">
                           <h4>DD | MM</h4>
                           <h3>News Heading</h3>
                       </div>
                       <div className="news-content">
                           <p>Stay Tunned  for more Updates Stay Tunned  For More Updates</p>
                       </div>
                       <div className="attachment">
                           <Link to="#" target="_blank"><i className="bi bi-paperclip"></i></Link>
                       </div>
                   </div>
               </div>
                   </div>
               <div className="load-more">
                   <div className="next">Show More</div>
               </div>
          </div>

</div>
</div>
      </>
  )
}

export default News
